import { render, staticRenderFns } from "./BookingMargin.vue?vue&type=template&id=42f115e6&"
import script from "./BookingMargin.vue?vue&type=script&lang=js&"
export * from "./BookingMargin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports